module.exports = __webpack_public_path__ + "static/img/propose.b6093509.png";